module.exports = __webpack_public_path__ + "media/images/restaurant/areas/kyoto_osaka-a2a5666ac737532bc6aa63005c94ddea.png";